import React from "react";
import CustomLink from "../../../../components/Link";
const Plan = () => {
  return (
    <div className="tron_front_plan_wrapper">
      <div className="landingPage_container container">
        <div className="tron_front_plan_content">
          <div className="title">
            <h2 id="packages">Packages</h2>
          </div>
          <div className="table_sale_card">
            <Card
              className="dark_blue"
              discountText="package 1" 
              packageAmount="$25"
              mining="Package Profit"
              miningAmount="You Will Get ROI 0.30% Per Day For 600 Days."
              buttonText="BUY"
              buttonStyle="#e8c743"
              fontSize="20px"
              headingSize="45px"
            />
            <Card
              buttonText="BUY"
              buttonStyle="#e8c743"
              discountText="package 2"
              packageAmount="$100"
              mining="Package Profit"
              miningAmount="You Will Get ROI 0.50% Per Day For 600 Days."
              className="dark_blue"
              fontSize="20px"
              headingSize="45px"
            />
            <Card
              className="dark_blue"
              discountText="package 3"
              packageAmount="$500"
              mining="Package Profit"
              miningAmount="You Will Get ROI 0.50% Per Day For 600 Days."
              buttonText="BUY"
              buttonStyle="#e8c743"
              fontSize="20px"
              headingSize="45px"
            />
            <Card
              className="dark_blue"
              discountText="package 4"
              packageAmount="$1000"
              mining="Package Profit"
              miningAmount="You Will Get ROI 0.50% Per Day For 600 Days."
              buttonText="BUY"
              buttonStyle="#e8c743"
              fontSize="20px"
              headingSize="45px"
            />
            <Card
              discountText="package 5"
              packageAmount="$1500"
              mining="Package Profit"
              miningAmount="You Will Get ROI 0.50% Per Day For 600 Days."
              className="dark_blue"
              buttonText="BUY"
              buttonStyle="#e8c743"
              fontSize="20px"
              headingSize="45px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plan;

const Card = ({
  className,
  discountStyle,
  discountText,
  h4Style,
  headingSize,
  fontSize,
  fontWeight,
  margin,
  buttonText,
  textGray,
  buttonStyle,
  buttonColor,
  discountTextClass,
  packageAmount,
  miningAmount,
}) => {
  return (
    <div className={`table_sale ${className}`}>
      <p className="center_element">
        <span
          style={{
            background: `${discountStyle}`,
            // fontSize: `${fontSize}`,
            fontWeight: `${fontWeight}`,
          }}
          className={discountTextClass}
        >
          {discountText}
        </span>
      </p>
      <div className="horizontal" style={{ margin: `${margin}` }}></div>
      <h4
        className={`center_element text_white ${textGray}`}
        style={{ color: `${h4Style}`, fontSize: `${headingSize}` }}
      >
        {packageAmount}
      </h4>
      {/* <p className={`center_element text_white ${textGray}`}>0.5 US dollars</p> */}
      <div className="horizontal"></div>
      <p
        className={`center_element text_white ${textGray}`}
        style={{ fontSize: `${fontSize}` }}
      >
        <br />
        {miningAmount}
      </p>
      <div className="button">
        <CustomLink
           to ="/login"
          className="card_btn"
          style={{ backgroundColor: `${buttonStyle}` }}
        >
          <span
            className="buy_button"
            style={{
              color: `${buttonColor} !important`,
            }}
          >
            {buttonText}
          </span>
        </CustomLink>
      </div>
    </div>
  );
};
